const getInitialState = () => ({
  tiers: {}
});

export default {
  namespaced: true,
  state: getInitialState,
  getters: {
    tiers: _state => _state.tiers
  },
  mutations: {
    FETCH_REPLACEMENT_SUCCESS(state, payload) {
      state.tiers = { ...payload };
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
  },
  actions: {
    FETCH_REPLACEMENT({ commit }) {
      return this.$api.get('/api/v2/cses/automatic-disk-replacement/settings/')
        .then(({ data }) => {
          commit('FETCH_REPLACEMENT_SUCCESS', data);
        });
    },
    SAVE_REPLACEMENT({ commit }, tiers) {
      return this.$api.put('/api/v2/cses/automatic-disk-replacement/settings/', tiers)
        .then(({ data }) => {
          commit('FETCH_REPLACEMENT_SUCCESS', data);
        });
    }
  }
};
